var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-page__back-to-top"},[_c('span',{staticClass:"back-to-top-link subhead",on:{"click":_vm.onClick}},[_vm._v("\n    ページトップへ ▲\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }